

















































































































































































import { API_SETTING_WEIXIN_API, API_UPLOAD_QR_CODE } from "@/configs/Apis";
import { MSG_INVALID_PAGE, MSG_MODIFY_SUCCESS } from "@/configs/Consts";
import { hasPermission, isEmptyOrWhiteSpace, showError, showSuccess, showWarning } from "@/utils/Common";
import { Fetcher as Ajax } from "@/utils/Request";
import { Component, Vue } from "vue-property-decorator";
@Component({
  filters: {
    passIt: function (str: string) {
      if (!str) {
        return "";
      }
      const len = str.length;
      if (len > 6) {
        return str.substring(0, 3) + "*".repeat(len - 6) + str.substring(len - 3);
      }
      return str;
    }
  }
})
export default class WeixinApiSetting extends Vue {
  isEditing = false;
  settingItem: any = {};
  imgUrl = "";
  created() {
    this.loadData();
  }

  hasPerm(checkedPerm: string) {
    return hasPermission(this.$store.getters["user/user"] || {}, checkedPerm);
  }

  loadData() {
    Ajax.queryData(API_SETTING_WEIXIN_API, {}, "GET")
      .then(data => {
        this.settingItem = JSON.parse(JSON.stringify(data || {}));
        this.imgUrl = this.settingItem.qrCode || "";
      })
      .catch(() => "");
  }

  get uploadAction() {
    return Ajax.formatApiUrl(API_UPLOAD_QR_CODE, {});
  }

  get showFileList() {
    return isEmptyOrWhiteSpace(this.imgUrl);
  }

  handleBgImgSuccess(res: any, file: any) {
    this.imgUrl = URL.createObjectURL(file.raw);
    this.settingItem.qrCode = file.response.location;
    showSuccess("上传成功");
  }

  beforeBgImgUpload(file: any) {
    if (!file) {
      return false;
    }
    const match = /\.(.+)$/g.exec(file.name);
    if (!match || !match.length) {
      return false;
    }
    const ext: string = match[match.length - 1];
    if (["JPG", "JPEG", "GIF", "PNG"].indexOf(ext.toUpperCase()) === -1) {
      showWarning("文件只能是图片格式!");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      showWarning("图片大小不能超过 2MB!");
      return false;
    }
    return true;
  }

  editInfo() {
    this.isEditing = true;
  }

  cancelEdit() {
    this.isEditing = false;
    this.loadData();
  }

  submitData() {
    const form = this.$refs.settingForm as any;
    form.validate((isValid: boolean) => {
      if (!isValid) {
        showWarning(MSG_INVALID_PAGE);
        return;
      }
      Ajax.saveData(
        API_SETTING_WEIXIN_API,
        JSON.parse(JSON.stringify(this.settingItem)),
        "PUT"
      )
        .then(() => {
          showSuccess(MSG_MODIFY_SUCCESS);
        })
        .catch(({ message }) => showError(message));
    });
  }
}
